import script from "./DocView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocView.vue?vue&type=script&setup=true&lang=js"

import "./DocView.vue?vue&type=style&index=0&id=34674944&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34674944"]])

export default __exports__